import React from 'react'

export const OrderFrom = ({ classes, nextOpeningTime }) => (
  <span className={classes.displayedTime}>Order From {nextOpeningTime}</span>
)
